import {
  FulfillGetUserTradingAccountsAction,
  GetUserTradingAccountsAction,
} from '../actions/GraphQLActions'
import { ViewerWrapper } from '../types'
import * as constants from '../constants'
import { FulfillBalanceUpdate } from '../actions/TradeActions'

export function userAccount(
  accountsState: ViewerWrapper = defaultState,
  action: GetUserTradingAccountsAction | FulfillGetUserTradingAccountsAction | FulfillBalanceUpdate
): ViewerWrapper {
  switch (action.type) {
    case constants.GET_USER_TRADING_ACCOUNTS: {
      return { ...accountsState }
    }
    case constants.FULFILL_BALANCE_UPDATE: {
      const { equity, margin, balance, login } = action
      const accounts = accountsState.viewer.accounts.map(acc =>
        acc.login !== login.toString() ? acc : { ...acc, equity, margin, balance }
      )
      return { ...accountsState, viewer: { ...accountsState.viewer, accounts } }
    }
    case constants.FULFILL_USER_ACCOUNT: {
      // const accounts = action.viewer.viewer.accounts.map(acc => {
      //    return {...acc, serverType: getServerTypeByAccountType(acc.__typename) as ServerType}
      // });
      // const filteredAccounts = accounts.filter(acc => acc.login === null);
      //
      // const viewer = {... action.viewer.viewer, filteredAccounts};
      return { ...action.viewer }
    }
    default:
      return accountsState
  }
}

const defaultState = {
  viewer: {
    id: 0,
    email: '',
    locale: '',
    company: '',
    accounts: [],
    isPhoneVerificationRequired: false,
  },
}
